module.exports = __webpack_public_path__ + "static/bbis-hero-4-44d1815f51bf08f1b3cc3eeb32647121.jpg";